var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ob1-cards",
    {
      staticClass: "device-card d-flex flex-column h-100",
      attrs: {
        "data-test-id": "device-card",
        "additional-classes": "px-1 pt-2",
        "is-multiple": true,
        "is-selected": _vm.deviceInCart,
        "with-composite-link": false,
      },
    },
    [
      _c(
        "a",
        {
          staticClass:
            "card-link-wrapper text-decoration-none text-dark d-block",
          attrs: {
            href: _vm.device.detailsUrl,
            "data-oevent-category": "selecteur_produit",
            "data-oevent-action":
              "bloc_" + _vm.device.name.split(" ").join("_"),
            "data-oevent-label": _vm.device.detailsUrl,
          },
        },
        [
          _c(
            "div",
            { staticClass: "d-flex flex-column h-100 justify-content-between" },
            [
              _vm.device.banner
                ? _c("ob1-tag", {
                    staticClass: "banner",
                    attrs: { label: _vm.device.banner },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex flex-row" }, [
                _vm.device.image
                  ? _c(
                      "div",
                      { staticClass: "img-device m-1" },
                      [
                        _c("selector-color-chips", {
                          attrs: { colors: _vm.device.availableColors },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "image-container" },
                          [
                            _c("ob1-picture", {
                              staticClass: "device-picture",
                              attrs: { visual: _vm.device.image },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "infos pr-1" }, [
                  _c(
                    "div",
                    { staticClass: "mobile-infos" },
                    [
                      _c("div", [_vm._v(_vm._s(_vm.device.brand))]),
                      _vm._v(" "),
                      _c(
                        "h2",
                        {
                          staticClass:
                            "no-signature standard py-0 my-0 fw-normal",
                        },
                        [
                          _c("strong", { staticClass: "standard" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm.device.name) +
                                "\n                            "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.device.reviewsStats
                        ? _c("Rating", {
                            attrs: {
                              average: _vm.device.reviewsStats.average,
                              "rating-results-height": 1.01,
                              "font-size": 0.875,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.device.refurbished
                        ? _c("ob1-capsule", {
                            attrs: {
                              label: "Reconditionné",
                              "is-context": "",
                              "is-small": "",
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.device.availabilityStatus &&
                      _vm.device.availabilityStatus.label
                        ? _c("ob1-tag", {
                            staticClass: "mt-1",
                            attrs: {
                              type: "unavailable",
                              label: _vm.device.availabilityStatus.label,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "infos-price" },
                    [
                      _c("device-price", {
                        attrs: {
                          "compact-price": true,
                          "is-cents-format": true,
                          "multiple-price": _vm.device.multiplePrices,
                          "total-price-with-promo":
                            _vm.device.discountedPriceInCents,
                          "total-price-without-promo":
                            _vm.getPriceWithoutPromo(),
                          "monthly-amount-in-cents":
                            _vm.getMonthlyAmountInCents(),
                          "monthly-duration": _vm.getMonthlyDuration(),
                          "generic-label": _vm.getPaymentInfoLabel(),
                          "loan-rate-zero-label": _vm.getZeroRateLabel(),
                          "is-price-inversion-enabled":
                            _vm.isPriceInversionEnabled(),
                          "advantage-accessibility": _vm.advantageAccessibility,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "infos-advantage py-1" }, [
                _vm.device.advantageValues
                  ? _c(
                      "div",
                      [
                        _c("advantage-bloc", {
                          attrs: {
                            "advantage-messages": _vm.advantageMessages,
                            discount: _vm.device.advantageValues.discount,
                            odr: _vm.device.advantageValues.odr,
                            "bonus-recovery":
                              _vm.device.advantageValues.bonusRecovery,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "infos-cart" }, [
                _c(
                  "div",
                  { staticClass: "px-1 pb-1" },
                  [
                    _vm.deviceInCart
                      ? _c("ob1-message-alerte", {
                          attrs: {
                            type: "success",
                            title: "Déjà dans votre panier",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _vm.showSoldByInfos
                ? _c(
                    "div",
                    { staticClass: "infos-seller" },
                    [
                      _c("sold-by-card", {
                        attrs: {
                          title: _vm.sellerLabel,
                          "sold-by-orange": _vm.device.firstParty,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "d-flex align-items-center payment-solutions-details gap-xxl-2 pt-1",
        },
        [
          _vm.showDasTooltip(_vm.device)
            ? _c("das-tooltip", {
                attrs: {
                  id: "tooltip-device" + _vm.index,
                  das: _vm.device.dasAccessible,
                  "aria-label": _vm.dasAriaLabel(
                    _vm.device.brand,
                    _vm.device.name
                  ),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.device.energyLabel
            ? _c("energy-label", {
                staticClass: "energy-label-padding ms-auto",
                attrs: {
                  id: _vm.device.seoId,
                  "energy-label": _vm.device.energyLabel,
                  "with-link": false,
                  "with-custom-image-class": true,
                  "with-popin": false,
                  "data-oevent-category": "selecteur_produit",
                },
                on: { energyLabelClick: _vm.handleEnergyLabelClick },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showFundingDetailsLink(_vm.device)
            ? _c("FundingDetailsLink", {
                staticClass: "ms-auto",
                attrs: {
                  "seo-id": _vm.device.seoId,
                  text: _vm.fundingDetails.linkText,
                  "device-name": _vm.device.brand + " " + _vm.device.name,
                },
                on: { fundingDetailsClick: _vm.handleFundingDetailsClick },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }